import React, { FC, useEffect, useState } from 'react';
import { Box } from '~Styles';
import Icon from '~ComponentsImproved/Icon';
import Heading from '~ComponentsImproved/Typography/Heading';
import { useI18n } from '~Hooks';
import { STATUS_COLORS } from '../PrinterStatus/index';
import Paragraph from '~ComponentsImproved/Typography/Paragraph';
import WifiIcon from '~Assets/icons/wifi.svg';
import WifiOffIcon from '~Assets/icons/wifi_off.svg';
import { StyledBox } from '../PrinterStatus/styles';

/** Component in System Status & Printer Status that is used to show internet connection */
const InternetStatus: FC = () => {
  const { i18n } = useI18n();

  const [hasInternetConnection, setHasInternetConnection] = useState<boolean>(true);

  useEffect(() => {
    // Ping google to check if there is internet connection
    fetch('https://www.google.com', { mode: 'no-cors' })
      .then((res) => {
        setHasInternetConnection(true);
      })
      .catch((err) => {
        setHasInternetConnection(false);
      });
  }, []);

  return (
    <StyledBox fluid display="flex" alignItems="flex-start" gap="small" padding="small">
      <Icon
        src={hasInternetConnection ? WifiIcon : WifiOffIcon}
        color={hasInternetConnection ? STATUS_COLORS.OK : STATUS_COLORS.ERROR}
      />
      <Box display="flex" flexDirection="column" alignItems="flex-start">
        <Heading level={4}>{i18n('PrinterStatus.InternetConnection')}</Heading>
        <Paragraph level={5} color="var(--colorBlueGray1200)">
          {hasInternetConnection
            ? i18n('Printer.Status.InternetOnline')
            : i18n('Printer.Status.InternetOffline')}
        </Paragraph>
      </Box>
    </StyledBox>
  );
};

export default InternetStatus;
